/**
 * COM-FOUNDATION — FE build stamp.  Regenerated on every frontend
 * supervisor restart by scripts/stamp_fe_build.sh.  The values below
 * are the authoritative identity of the JS source tree at build time;
 * the served-bundle verifier compares them to the SHA actually
 * present in the deployed JS bundle, and to /api/runtime/fingerprint.
 *
 * `revision_verified` is false when the SHA could not be established from
 * this source tree or from the build pipeline and was carried over from an
 * earlier stamp.  A false value means the SHA identifies an EARLIER commit:
 * parity must not be reported as proof of the deployed revision.
 *
 * DO NOT EDIT BY HAND — automation overwrites this file.
 */
export const FE_BUILD = {
  sha: '2d0e0131cfe3',
  revision_source: 'preserved_from_earlier_stamp',
  revision_verified: false,
  build_tag: '',
  deployment_name: '',
  built_at: '2026-11-04T19:51:51Z',
  sprint: 'COM-FOUNDATION',
  runtime_epoch: '2026-COM-FOUNDATION',
  expected_be_epoch: '2026-COM-FOUNDATION',
  api_compat_epoch: 'v1.0.0',
  spec: 'COM-FOUNDATION/fe-build/v1',
};
